export default {
  autocompleteDocumentCategories: [],
}